import { Box, Card, CardActions, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { PlanFilterItem } from './PlanFilterItem';
import { filters } from '../pricingData';
import { TPlanFilterProps } from './types';

export const PlanFilter: FC<TPlanFilterProps> = ({ checkedArray, handleChecked }) => {
	return (
		<Card
			sx={{
				backgroundColor: '#cfdde8',
				p: '1px 5px 5px 5px',
			}}
		>
			<CardActions
				sx={{
					m: 0,
					p: 0, // '0 5px 5px 5px',
					height: '100%',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
						height: '100%',
					}}
				>
					<Typography
						color="primary"
						sx={{
							fontSize: '1rem',
							p: 0,
							m: 0,
							mt: '0px',
							fontWeight: '550',
						}}
					>
						Specify which schemes you want to use in your business:
					</Typography>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							gap: '4px',
						}}
					>
						{filters.map((filter, index) => (
							<PlanFilterItem
								key={filter.name}
								name={filter.name}
								text={filter.text}
								checked={checkedArray[index]}
								onChecked={() => handleChecked(index)}
							/>
						))}
						<PlanFilterItem
							key="all"
							name="Show All"
							text=""
							checked={checkedArray.every((checked) => !checked)}
							onChecked={() => handleChecked(-1)}
						/>
					</Box>
				</Box>
			</CardActions>
		</Card>
	);
};
